const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#96D5EA",
    fillOpacity: 0.2,
    style: {
      fill: "#96D5EA",
      fill: "color(display-p3 0.5882 0.8353 0.9176)",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C6 9.60324 6 8.40486 6.57113 7.5417C6.82616 7.15626 7.15626 6.82616 7.5417 6.57113C8.40486 6 9.60324 6 12 6C14.3968 6 15.5951 6 16.4583 6.57113C16.8437 6.82616 17.1738 7.15626 17.4289 7.5417C18 8.40486 18 9.60324 18 12C18 14.3968 18 15.5951 17.4289 16.4583C17.1738 16.8437 16.8437 17.1738 16.4583 17.4289C15.5951 18 14.3968 18 12 18C9.60324 18 8.40486 18 7.5417 17.4289C7.15626 17.1738 6.82616 16.8437 6.57113 16.4583C6 15.5951 6 14.3968 6 12ZM15.1062 12.0002C15.1062 13.7157 13.7154 15.1064 11.9999 15.1064C10.2843 15.1064 8.89362 13.7157 8.89362 12.0002C8.89362 10.2846 10.2843 8.89388 11.9999 8.89388C13.7154 8.89388 15.1062 10.2846 15.1062 12.0002ZM11.9999 14.0555C13.135 14.0555 14.0552 13.1353 14.0552 12.0002C14.0552 10.865 13.135 9.94482 11.9999 9.94482C10.8648 9.94482 9.94456 10.865 9.94456 12.0002C9.94456 13.1353 10.8648 14.0555 11.9999 14.0555ZM15.2288 9.4677C15.632 9.4677 15.9587 9.14092 15.9587 8.73782C15.9587 8.33471 15.632 8.00793 15.2288 8.00793C14.8257 8.00793 14.499 8.33471 14.499 8.73782C14.499 9.14092 14.8257 9.4677 15.2288 9.4677Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.381330196bc9a464084c3665ad0c7833.svg";
export { ForwardRef as ReactComponent };